
import {
    Component,
    Input,
    OnChanges,
    SimpleChanges, OnDestroy, Output, EventEmitter, AfterViewInit
} from '@angular/core';
import * as c3 from 'c3';
import { GraphUtilsService } from '../../services/graph-utils.service';
import { DataService } from '../../services/data.service';
import { thresholdFreedmanDiaconis } from 'd3';
let chart;
@Component({
    selector: 'app-c3-scatter-plot',
    templateUrl: './c3-scatter-plot.component.html',
    styleUrls: ['./c3-scatter-plot.component.scss'],
    standalone: false
})
export class C3ScatterPlotComponent implements OnChanges, AfterViewInit, OnDestroy {
    @Input() data: any;
    @Input() IndependentParamName: any;
    @Input() DependentParamName: any;
    subscription: any;
    constructor(private dataSer: DataService) {
        this.subscription = dataSer.events.subscribe(this.drawChartSubscription);
    }

    drawChartSubscription = (res: any) => {
        setTimeout(() => {
            this.drawScatterchart(this.data);
        }, 100);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (chart) {
            chart.destroy();
        }
        this.checkAndReplotGraph();
    }

    ngAfterViewInit(): void {
        this.checkAndReplotGraph();
    }

    checkAndReplotGraph() {
        if (this.data && this.data.length) {
            this.drawScatterchart(this.data);
        } else {
            chart = null;
        }
    }
    drawScatterchart(data) {
        chart = c3.generate({
            data: {
                xs: { Y: 'X' },
                columns: [
                    ['X', ...data.map(elem => elem.x)],
                    ['Y', ...data.map(elem => elem.y)]
                ],
                colors: { Y: 'blue', TrendsLine: 'red' },
                type: 'scatter'
            },
            legend: { show: false },
            tooltip: { grouped: false },

            axis: {
                x: {
                    label: { text: this.IndependentParamName, position: 'outer-right' },
                    tick: { fit: false }
                },
                y: {
                    label: { text: this.DependentParamName, position: 'outer-top' }
                }
            },
            point: { show: false },
            zoom: { type: 'scroll', enabled: true },
            grid: { lines: { front: false } }
        });

        setTimeout(() => {
            if (!chart) {
                return;
            }
            chart.load({
                xs: {
                    TrendsLine: 'Trends'
                },
                columns: [
                    ['Trends', ...data.map(elem => elem.x)],
                    ['TrendsLine', ...data.map(elem => elem.trendLine)],
                ],
                type: 'line',
            });
        }, 100);

    }


    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }


}
